import React from 'react';
import { Select, CheckboxGroup, Checkbox, Wrap, WrapItem } from '@chakra-ui/react';
import { DEPARTMENTS } from '../../constants/departments';

/**
 * DepartmentSelect — single or multi-select backed by the global DEPARTMENTS enum.
 *
 * Single-select (default):
 *   <DepartmentSelect name="department" value={val} onChange={handler} includeAll />
 *   onChange receives the native Select change event.
 *
 * Multi-select (isMulti):
 *   <DepartmentSelect isMulti value={arrayOfNames} onChange={setArrayOfNames} />
 *   onChange receives a string[] of selected department names.
 */
const DepartmentSelect = ({
  value,
  onChange,
  includeAll = false,
  isMulti = false,
  name,
  placeholder,
  ...rest
}) => {
  if (isMulti) {
    return (
      <CheckboxGroup value={value} onChange={onChange}>
        <Wrap spacing={4} {...rest}>
          {DEPARTMENTS.map(dept => (
            <WrapItem key={dept}>
              <Checkbox value={dept}>{dept}</Checkbox>
            </WrapItem>
          ))}
        </Wrap>
      </CheckboxGroup>
    );
  }

  return (
    <Select name={name} value={value} onChange={onChange} {...rest}>
      {includeAll && <option value="All">All Departments</option>}
      {placeholder && !includeAll && <option value="">{placeholder}</option>}
      {DEPARTMENTS.map(dept => (
        <option key={dept} value={dept}>{dept}</option>
      ))}
    </Select>
  );
};

export default DepartmentSelect;
